<i18n locale="en">
{
  "highlights": "Highlights"
}
</i18n>
<template>
  <div class="upsell-takeover" data-testid="upsell-takeover">
    <div
      class="upsell-takeover__content mx-auto flex w-full flex-col items-center p-6 pt-12 pb-10"
    >
      <UpsellHero
        :title="title"
        :description="description"
        :preview-data="previewData"
      />
      <div class="upsell-takeover__section flex w-full flex-col gap-4">
        <h2 class="upsell-takeover__heading">{{ t('highlights') }}</h2>
        <UpsellFeatures
          :app-icon-background-color="appIconBackgroundColor"
          :app-icon-url="appIconUrl"
          :features="features"
        />
      </div>
      <PlanComparisonTable
        :caption="tableCaption"
        :current-plan="plans[0]"
        :plans="plans"
        :sections="sections"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { usePersonalizedProUpsellPreview } from '../composables/usePersonalizedProUpsellPreview'
import { useProUpsellContent } from '../composables/useProUpsellContent'

import PlanComparisonTable from './PlanComparisonTable.vue'
import UpsellFeatures from './UpsellFeatures.vue'
import UpsellHero from './UpsellHero.vue'
const { t } = useI18n()

const { description, features, plans, sections, tableCaption, title } =
  useProUpsellContent()
const { appIconBackgroundColor, appIconUrl, previewData } =
  usePersonalizedProUpsellPreview()
</script>

<style lang="scss" scoped>
@use '@/styles/breakpoints';

// Light upsell surface from the tier-upgrades design (Figma nodes 806:46646
// mobile / 806:44525 web).
.upsell-takeover {
  min-height: 100%;

  // 1009px web design frame + 24px side padding on each side.
  &__content {
    max-width: 1057px;
  }

  &__section {
    max-width: 900px;
    margin-top: 24px;
  }

  :deep(.plan-comparison-table) {
    max-width: 900px;
    margin-top: 56px;
  }

  &__heading {
    margin: 0;
    margin-top: 24px;
    color: var(--text-color-primary);
    font-size: 18px;
    font-weight: 500;
    line-height: 25.2px;

    @include breakpoints.respond-to('md-and-up') {
      font-size: 22px;
      line-height: 28.4px;
    }
  }
}
</style>
